import { render, staticRenderFns } from "./SignUpLayout.vue?vue&type=template&id=15722752&"
import script from "./SignUpLayout.vue?vue&type=script&lang=js&"
export * from "./SignUpLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports